import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import "@/common/css/normalize.css"
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import http from "./http/index"
import common from "./common/js/common"
import {baseURL} from "./config/config.default"
import pinia from "./store"
import '@/common/css/wickedcss.min.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import Vant from "vant";
// 2. 引入组件样式
import 'vant/lib/index.css';
//Naive UI
import naive from 'naive-ui'

// px->rem
//import "amfe-flexible";
import '@/util/rem.js'

import Plugin from 'v-fit-columns';

import likeUI from './components/index';
//全局引入组件
import headerMenu from "@/components/headerMenu/index.vue"
import formulaInformation from "@/components/formulaInformation/index.vue"
import contactUs from "@/components/contactUs/index.vue"
import mapComponent from "@/components/MapContainer.vue"
import backTop from "@/components/backTop/index.vue"
import vChart from "@/components/vChart/index.vue"
import vChartHistogram from "@/components/vChartHistogram/index.vue"
import loanReservation from "@/components/loanReservation/index.vue"
import privacyClause from "@/components/privacyClause/index.vue"
import onlineApplication from "@/components/onlineApplication/index.vue";
import mDialog from "@/components/mDialog/index.vue"
import mLoading from "@/components/mLoading/index.vue"

const app = createApp(App);
app.use(naive);
app.config.globalProperties.$http = http;
app.config.globalProperties.$common = common;
app.config.globalProperties.$uploadImgUrl = baseURL + "tools/sign_upload";
app.config.globalProperties.$uploadImgUrlAlias = baseURL + "/common/upload/file";

app.component('headerMenu', headerMenu);
app.component('formulaInformation', formulaInformation);
app.component('contactUs', contactUs);
app.component('mapComponent', mapComponent);
app.component('backTop', backTop);
app.component("vChart", vChart);
app.component("vChartHistogram", vChartHistogram);
app.component("loanReservation", loanReservation);
app.component("privacyClause", privacyClause);
app.component("onlineApplication", onlineApplication);
app.component("mDialog", mDialog);
app.component("mLoading", mLoading);

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

// app.use(store);
app.use(router);
app.use(ElementPlus, {locale: zhCn});
app.use(Plugin);
app.use(likeUI);
app.use(pinia);
app.use(Antd);
app.use(Vant);
app.mount('#app');
